import { useState } from 'react';
import { Card, Typography, Input, Button, Table, Alert, message } from '../../ui';
import { request } from '../../api/client';

export function NlAnalyticsPage() {
  const [q, setQ] = useState('Top 10 retailers by sales this month');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const ask = async () => {
    setLoading(true);
    try {
      const r = await request<any>({ url: '/ai/analytics/nl', method: 'POST', data: { question: q } });
      setResult(r);
    } catch (e: any) {
      message.error(e.response?.data?.error?.message ?? 'Failed');
    } finally {
      setLoading(false);
    }
  };

  const columns = result?.rows?.[0]
    ? Object.keys(result.rows[0]).map((k) => ({ title: k, dataIndex: k }))
    : [];

  return (
    <div>
      <Typography.Title level={4}>Natural-Language Analytics</Typography.Title>
      <Card>
        <Alert type="info" className="mb-4"
          title="Ask a question. AI translates to SQL on a whitelisted set of tables (read-only)." />
        <div className="mb-4 flex w-full">
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="e.g. Top 10 SKUs in Maharashtra last quarter" />
          <Button variant="primary" loading={loading} onClick={ask}>Ask</Button>
        </div>
        {result?.sql && (
          <Card title="Generated SQL" className="mb-3">
            <pre style={{ whiteSpace: 'pre-wrap' }}>{result.sql}</pre>
            {result.explain && <Typography.Paragraph type="secondary">{result.explain}</Typography.Paragraph>}
          </Card>
        )}
        {result?.rows && (
          <Table rowKey={(_, i) => String(i)} dataSource={result.rows} columns={columns} size="small" />
        )}
        {result?.error && <Alert type="error" title={result.error} />}
      </Card>
    </div>
  );
}
